import { render, staticRenderFns } from "./RecommendedProductSlider.vue?vue&type=template&id=0831daae&scoped=true&"
import script from "./RecommendedProductSlider.vue?vue&type=script&lang=js&"
export * from "./RecommendedProductSlider.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedProductSlider.vue?vue&type=style&index=0&id=0831daae&scoped=true&lang=css&"
import style1 from "./RecommendedProductSlider.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0831daae",
  null
  
)

export default component.exports